import { useEffect } from 'react';
import { createFocusTrap } from 'focus-trap';
import createFocusTrapV2 from 'focus-trap-v2';
import noop from '@atlaskit/ds-lib/noop';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
export var useFocusManager = function useFocusManager(_ref) {
  var popupRef = _ref.popupRef,
    initialFocusRef = _ref.initialFocusRef,
    autoFocus = _ref.autoFocus;
  useEffect(function () {
    if (!popupRef) {
      return noop;
    }
    var focusTrap;
    if (getBooleanFF('platform.design-system-team.focus-trap-upgrade_p2cei')) {
      var trapConfig = {
        clickOutsideDeactivates: true,
        escapeDeactivates: true,
        // @ts-ignore: The multiple focus-trap packages is causing a type error that does not affect functionality
        initialFocus: autoFocus ? initialFocusRef || popupRef : false,
        fallbackFocus: popupRef,
        returnFocusOnDeactivate: true
      };
      focusTrap = createFocusTrap(popupRef, trapConfig);
    } else {
      var _trapConfig = {
        clickOutsideDeactivates: true,
        escapeDeactivates: true,
        initialFocus: initialFocusRef || popupRef,
        fallbackFocus: popupRef,
        returnFocusOnDeactivate: true
      };
      focusTrap = createFocusTrapV2(popupRef, _trapConfig);
    }

    // wait for the popup to reposition itself before we focus
    var frameId = requestAnimationFrame(function () {
      frameId = null;
      focusTrap.activate();
    });
    return function () {
      if (frameId != null) {
        cancelAnimationFrame(frameId);
        frameId = null;
      }
      focusTrap.deactivate();
    };
  }, [popupRef, initialFocusRef, autoFocus]);
};